module.exports = __webpack_public_path__ + "static/fairchance_card_img3@2x-f0d7fe74c05bbc5b496be1f934217552.jpg";